"use client";
import { signIn } from "next-auth/react";
import { FaGoogle } from "react-icons/fa";

const GoogleLogin = () => {
  function handleGoogleSignIn() {
    signIn("google", { callbackUrl: "/" });
  }
  return (
    <button
      onClick={handleGoogleSignIn}
      type="button"
      className="group flex-1 py-3 border border-border flex items-center justify-center gap-2 px-4 text-sm font-semibold rounded-xl text-foreground bg-white hover:bg-brand-light/40 hover:border-brand-light focus:outline-none focus:ring-2 focus:ring-brand-sky/20 transition-all duration-200 shadow-brand-sm"
    >
      <div className="w-5 h-5 flex items-center justify-center text-[#dd4832] group-hover:scale-110 transition-transform duration-200">
        <FaGoogle size={16} />
      </div>
      Google
    </button>
  );
};

export default GoogleLogin;